import { render, staticRenderFns } from "./StatView.vue?vue&type=template&id=41d9dc8c&"
import script from "./StatView.vue?vue&type=script&lang=js&"
export * from "./StatView.vue?vue&type=script&lang=js&"
import style0 from "./StatView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "StatView.vue"
export default component.exports